import { render, staticRenderFns } from "./BasePassword.vue?vue&type=template&id=68b4e07a"
import script from "./BasePassword.vue?vue&type=script&lang=js"
export * from "./BasePassword.vue?vue&type=script&lang=js"
import style0 from "./BasePassword.vue?vue&type=style&index=0&id=68b4e07a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports